import { render, staticRenderFns } from "./culturalHeritageDetail.vue?vue&type=template&id=c70f2366&scoped=true"
import script from "./culturalHeritageDetail.vue?vue&type=script&lang=js"
export * from "./culturalHeritageDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=c70f2366&prod&scoped=true&lang=css&external"
import style1 from "./culturalHeritageDetail.vue?vue&type=style&index=1&id=c70f2366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70f2366",
  null
  
)

export default component.exports